import * as noUiSlider from "nouislider";
window.noUiSlider = noUiSlider;
// CSS 
import 'nouislider/dist/nouislider.min.css';